


































import { Component, Vue } from 'vue-property-decorator'
import WidgetTitle from '@/components/common/WidgetTitle.vue'
import { CakeFilling } from '@/shared/models/fillings'
import Loader from '@/components/common/Loader.vue'
import CakeCard from '@/components/cakes/card/Card.vue'
import API from '@/api/products'
import { ProductListItem } from '@/shared/models/cakes'

const customCakeIdsToShowAsFillings = '3788,3790,3791'

@Component({
  components: {
    WidgetTitle,
    Loader,
    CakeCard
  }
})
export default class Fillings extends Vue {
  isLoading = true
  listOfCustomCakesAsFillings: Array<ProductListItem> = []

  get fillings(): Array<CakeFilling> {
    return this.$store.getters.fillings
  }

  mounted(): void {
    API.getCakes({ include: customCakeIdsToShowAsFillings }).then(response => {
      this.listOfCustomCakesAsFillings = response?.data || []
      if (this.fillings.length) {
        this.isLoading = false
      } else {
        this.$store.dispatch('getFillings').finally(() => {
          this.isLoading = false
        })
      }
    })
  }
}
